import { createSlice } from "@reduxjs/toolkit"

import { addCasesForThunks } from "src/store/utils"

import thunks from "./thunks"
import reducers from "./reducers"
import initialState from "./initialState"

export const commonSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers,
  extraReducers(builder) {
    addCasesForThunks(builder, thunks)
  },
})

// Export only the reducer actions to be ran outside of the context to thunks.
// In other words, using the dispatch(reducerName({...})).
// Remember, you can not await the dispatch of a reducer action.
// export const {} = commonSlice.actions

// Reducer is used by the store to set the state of the user slice
export default commonSlice.reducer

// Export selectors and thunks to be able to be used from components easily
// in terms of the imports.
export * from "./thunks"
export * from "./selectors"
